<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// ===== 1. IMPORTS =====
import { onBeforeMount } from 'vue'
import { useI18n } from 'vue-i18n'
import ColorModeCycle from '@/components/ColorModeCycle.vue'
import constants from '@/exports/constants'
import { useCommonStore } from '@/stores/CommonStore'

// ===== 2. TYPE DEFINITIONS =====

// ===== 3. PROPS =====
defineOptions({ name: 'AccountSettingsAppearance' })

// ===== 4. EMITS =====

// ===== 5. COMPOSABLES & EXTERNAL DEPENDENCIES =====
const commonStore = useCommonStore()
const { setPageHeaders, setLayoutOptions } = commonStore
const { t } = useI18n()

// ===== 6. REACTIVE DATA =====

// ===== 7. COMPUTED PROPERTIES =====

// ===== 8. WATCHERS =====

// ===== 9. LIFECYCLE HOOKS =====
onBeforeMount((): void => {
  setPageHeaders({
    page: 'Account Settings',
    pageName: t('titles.settings'),
    pageNameKey: 'titles.settings',
    pageNameMobile: t('titles.settings'),
    pageNameMobileKey: 'titles.settings',
    pageIcon: 'fa-light fa-user-gear',
    searchEnabled: false,
    pageData: {},
    searching: false
  })
  setLayoutOptions({
    pageType: constants.pageType.list,
    headerText: t('titles.settings'),
    subHeaderText: '',
    showBackbutton: false,
    showUpgradeBanner: false,
    showAddNewButton: false
  })
})

// ===== 10. METHODS =====
</script>

<template>
  <div>
    <h2 class="sr-only">{{ t('accountSettings.appearance.tab') }}</h2>

    <ColorModeCycle />
  </div>
</template>
